import React, { useEffect } from 'react';
import s from './s.module.less';
import { Spin, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import MyAccount from './components/MyAccount';
import SubscriptionInfo from './components/SubscriptionInfo';
//import SubscriptionInfo from 'components/Subscription'
import KlarityPlanSubscriptionInfo from './components/KlarityPlanSubscriptionInfo';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import { shouldShowKlarityPlanUI } from 'utils/provider';
import ReferNRewards from 'components/ReferNRewards';
import useGetProviderReferralInfo from 'hooks/referral/useGetProviderReferralInfo';
import PracticePaymentBanner from './components/PracticePaymentBanner';
import useFetchProvider from 'hooks/useFetchProvider';
import ManageServiceBanner from './components/ManageServiceBanner';
import MedicationSettings from './components/MedicationSettings';
import { trackHeapEvent } from 'utils/analytics';
import PracticeStateConfig from 'components/PracticeStateConfig';
import EmailNotificationSettings from './components/EmailNotificationSettings';
import { EDot, getHasViewDotPage, setHasViewDotPage } from 'utils/localstore';
import TeamManagement from 'components/TeamManagement';
import useCurrentUser from 'hooks/useCurrentUser';
import { ERoleCode } from 'types/enumItems';

interface IProps {
    tabKey?: string;
    isKlarityAccount?: boolean;
    isShowSwitchAccount?: boolean;
}

const ManageSubscription = ({ tabKey, isKlarityAccount, isShowSwitchAccount }: IProps) => {
    const [homeInfo, loadingHome] = useProviderHomeInfo();
    const showKlarityPlanUI = shouldShowKlarityPlanUI(homeInfo);
    //todo use 1
    const [activeKey, setActiveKey] = React.useState<string>(tabKey || '1');

    const [, referalLoading] = useGetProviderReferralInfo();
    const [, loadingProvider] = useFetchProvider();
    const [currentUser] = useCurrentUser();
    const isClinicalAssistant = currentUser?.roleCode === ERoleCode.GROUP_CLINICAL_ASSISTANT;
    const finishServiceSetting = homeInfo && homeInfo.klarityServiceSetUpCompleted;

    useEffect(() => {
        if (tabKey) {
            setActiveKey(tabKey);
        }
    }, [tabKey]);

    // 检查是否已点击过（已查看过）
    const hasViewedEmailNotificationsDot = getHasViewDotPage(EDot.EMAIL_NOTIFICATIONS_NEW_TEXT_VISIT);
    // 只有当有新通知且未查看过时才显示蓝点
    const showEmailNotificationsDot = !hasViewedEmailNotificationsDot;

    let items: TabsProps['items'] = [
        {
            key: '1',
            label: 'My account',
            children: <MyAccount isKlarityAccount={isKlarityAccount} isShowSwitchAccount={isShowSwitchAccount} />,
        },
        {
            key: '7',
            label: 'Practice information',
            children: <PracticeStateConfig isSettingModal />,
        },
        {
            key: '9',
            label: 'Team',
            children: <TeamManagement />,
        },
        {
            key: '8',
            label: (
                <span className={s.tabLabelWithDot}>
                    Email notifications
                    {showEmailNotificationsDot && <span className={s.blueDot} />}
                </span>
            ),
            children: <EmailNotificationSettings />,
        },
        {
            key: '3',
            label: 'Subscription',
            children: showKlarityPlanUI ? <KlarityPlanSubscriptionInfo /> : <SubscriptionInfo />,
        },
        {
            key: '4',
            label: 'Medication settings',
            children: <MedicationSettings isKlarityHealthJoined={homeInfo?.klarityListed} />,
        },
        {
            key: '5',
            label: 'Refer and rewards',
            children: <ReferNRewards />,
        },
    ];
    if (!showKlarityPlanUI) {
        //kiwi user
        items = [
            {
                key: '1',
                label: 'My account',
                children: <MyAccount isKlarityAccount={isKlarityAccount} isShowSwitchAccount={isShowSwitchAccount} />,
            },
            {
                key: '7',
                label: 'Practice information',
                children: <PracticeStateConfig isSettingModal />,
            },
            ...(isClinicalAssistant
                ? []
                : [
                      {
                          key: '2',
                          label: 'Practice and payment',
                          children: <PracticePaymentBanner isFinish={finishServiceSetting} />,
                      },
                  ]),
            {
                key: '9',
                label: 'Team',
                children: <TeamManagement />,
            },
            {
                key: '8',
                label: (
                    <span className={s.tabLabelWithDot}>
                        Email notifications
                        {showEmailNotificationsDot && <span className={s.blueDot} />}
                    </span>
                ),
                children: <EmailNotificationSettings />,
            },
            // {
            //     key: '3',
            //     label: 'Service templates',
            //     children: <ManageServiceBanner />,
            // },
            // {
            //     key: '4',
            //     label: 'Medication settings',
            //     children: (
            //         <MedicationSettings
            //             isKlarityHealthJoined={homeInfo?.klarityListed}
            //         />
            //     ),
            // },
            {
                key: '5',
                label: 'Subscription',
                children: showKlarityPlanUI ? <KlarityPlanSubscriptionInfo /> : <SubscriptionInfo />,
            },
            {
                key: '6',
                label: 'Refer and rewards',
                children: <ReferNRewards />,
            },
        ];
    }

    return (
        <div className={s.wrap}>
            <Spin spinning={loadingHome || referalLoading || loadingProvider}>
                <div className={s.content}>
                    <div className={s.contentInner}>
                        <Tabs
                            activeKey={isClinicalAssistant && activeKey === '2' ? '1' : activeKey}
                            items={items}
                            onChange={(e) => {
                                trackHeapEvent('WebApp - Manage Subscription - Click - Tab Change', {
                                    fromTab: activeKey,
                                    toTab: e,
                                    isKlarityAccount,
                                    showKlarityPlanUI,
                                });
                                // 如果切换到 Email notifications tab，记录已查看，隐藏蓝点
                                if (e === '8' && showEmailNotificationsDot) {
                                    setHasViewDotPage(EDot.EMAIL_NOTIFICATIONS_NEW_TEXT_VISIT, 'true');
                                }
                                setActiveKey(e);
                            }}
                        />
                    </div>
                </div>
            </Spin>
        </div>
    );
};

export default ManageSubscription;
